import { Component, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  standalone: true,
  imports:[
    TranslateModule
  ]
})
export class ContactUsComponent implements OnInit {
  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {}
  dismiss() {
    this.modalCtrl.dismiss(); // Close modal without saving
  }
  async openUrl() {
    await Browser.open({ url: 'https://www.medpluspr.com/contactus' });
  }
}
